import {ChatConversion, MappingItem, ChatMessage } from '@/typings'
//import axios from 'axios';
import http from "../utils/axios"


// 定义 API 基础 URL（根据实际情况调整）
const API_BASE_URL = 'http://192.168.62.199:3000';
//const API_BASE_URL = 'http://192.168.59.201:8091';
//const API_BASE_URL = '';

//${API_BASE_URL}

// 解析会话内容
function loadChatByJson(conversation:ChatConversion)
{
  var messages:ChatMessage[] = [];
  //return messages;

  var mappingItems:MappingItem[] = [];
  var curMappingItem:MappingItem | undefined = conversation.mapping[conversation.currentNode];
  while(undefined != curMappingItem)
  {
      mappingItems.push(curMappingItem);
      if(null !=curMappingItem.parent)
      {
          curMappingItem = conversation.mapping[curMappingItem.parent];
          continue;
      }

      curMappingItem = undefined;
  }

  for(var i = 0; i < mappingItems.length;++i)
  {

      var item:MappingItem | undefined = mappingItems[i];
      if(undefined != item && undefined != item.guid)
      {
        // 解析字符串为对象
        const data = item.refs===""?null:JSON.parse(item.refs);
        // 提取 references 数组
        let references;
        let command = {
          name:"", 
          description:""
        };
        if(null !== data)
        {
          references = data.references;
          command = data.command;
        }
        var curMessage:ChatMessage = {
          role:item.role, 
          guid:item.guid, 
          createTime:item.createTime,
          content:item.content,
          references:references,
          command:{name:command.name,description:command.description}
        }
        messages.unshift(curMessage);
      }
  }
  return messages;
}

export { loadChatByJson };

// 封装查询聊天会话的 Axios 请求
function queryChatSession({pageSize = 1000, pageNO = 1, provider = "openai"}, token: string) {
  return http.get(`/conversations`,{
    params:{
      pageNO,
      pageSize,
      sort:"asc",
      order:"updateTime",
      provider
    },
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
}

export { queryChatSession };

function queryChatConversation(guid: string, token: string) {
  return http.get(`/conversation`,{
    params:{
      guid
    },
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
}

export { queryChatConversation };

function queryChatMessage(prompt: string, conversationGuid:string, parentGuid:string, token: string) {
  // if(parentGuid.length>0)
  // {
  //   return http.post(`/chat/openai`,{
  //       prompt,
  //       conversationGuid,
  //       parentGuid
  //     })
  // }
  // else
  // {
  //   return http.post(`/chat/openai`,{
  //     prompt,
  //     conversationGuid
  //   })
  // }
  const data = {
    prompt,
    conversationGuid,
    ...(parentGuid.length > 0 && { parentGuid })
  };

  return http.post(`/chat/openai`, data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}

export { queryChatMessage };



function createNewConversation(title: string, provider:string, token: string) {
    // 定义请求的 body 内容
    const body = {
      title: title,
      provider: provider
    };
    return http.post(`/conversation`,body,{
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      transformRequest: [(data, headers) => {
        headers['Content-Type'] = 'application/json';
        return JSON.stringify(data);
      }]
    })
}

export { createNewConversation };

function deleteConversation(guid: string, token: string) {
  return http.delete(`/conversation`,{
    params:
    {
      guid
    },
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
}

export { deleteConversation };

function updateConversation(title: string, guid:string, token: string) {
  return http.patch(`/conversation`,{
    title,
    guid
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
  );
}

export { updateConversation };

function pinConversation(guid: string, pinValue:boolean, token: string) {
  const pin = pinValue ? 1 : 0;
  return http.patch(`/conversation/lock`,{
    guid,
    pin
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
  );
}

export { pinConversation };


function createNewFeedback(conversationGuid: string, messageGuid: string, 
  feedback: number, token: string) 
  {
  // 定义请求的 body 内容
  const body = {
    conversationGuid: conversationGuid,
    messageGuid: messageGuid,
    feedback: feedback
  };
  return http.post(`/chat/feedback`,body,{
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    transformRequest: [(data, headers) => {
      headers['Content-Type'] = 'application/json';
      return JSON.stringify(data);
    }]
  })
}

export { createNewFeedback };